'use client';

import { useState, useEffect } from 'react';
import useAccountData from 'src/hooks/useAccountData';
import useWalletIsConnected from 'src/hooks/useWalletIsConnected';

export default function useIsAccountMarginEnabled() {
	const accountData = useAccountData();
	const [isAccountMarginEnabled, setIsAccountMarginEnabled] = useState(false);
	const isWalletConnected = useWalletIsConnected();

	// We use an effect with `accountData` as a dep so that it runs at an interval
	// frequent enough to promptly catch any updates to subaccount margin settings.
	useEffect(() => {
		if (!accountData?.client?.isSubscribed) {
			return;
		}

		const userAccount = accountData.client.getUserAccount();

		setIsAccountMarginEnabled(!!userAccount?.isMarginTradingEnabled);
	}, [accountData]);

	// If wallet disconnects, switch off.
	useEffect(() => {
		if (!isWalletConnected) {
			setIsAccountMarginEnabled(false);
		}
	}, [isWalletConnected]);

	return isAccountMarginEnabled;
}
